<template>
  <div class="container-doc">
    <v-card outlined>
      <v-subheader class="text--primary">Detalhes documento</v-subheader>
      <v-divider/>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <span class="caption font-weight-bold">Descrição</span>
          </v-list-item-title>
          <v-list-item-subtitle v-if="documento.descricao">
            <px-span-tooltip top :text="descricao(documento)" :tooltip="documento.descricao"/>
          </v-list-item-subtitle>
          <v-list-item-subtitle v-else>
            Não Informado
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>
            <span class="caption font-weight-bold">Email</span>
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ documento.email | naoInformado }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>
            <span class="caption font-weight-bold">Whatsapp</span>
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ documento.whatsapp | naoInformado }}
          </v-list-item-subtitle>
        </v-list-item-content>
         <v-list-item-content>
          <v-list-item-title>
            <span class="caption font-weight-bold">Notificar Vencimento</span>
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ documento.diasNotificar +" dias antes" | naoInformado }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </div>
</template>
<script>
import Vue from 'vue';

export default {
  props: {
    documento: Object,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    descricao() {
      return documento => Vue.filter('truncate')(documento.descricao, 30);
    },
  },
};
</script>

<style scoped>
.container-doc
{
  padding: 0.7rem;
}
</style>
